/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_SentInputs */

const en_reset_request_sent = /** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If an account exists for that address, a reset link is on its way.`)
};

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const ar_reset_request_sent = en_reset_request_sent;

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const he_reset_request_sent = en_reset_request_sent;

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const ur_reset_request_sent = en_reset_request_sent;

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const es_reset_request_sent = en_reset_request_sent;

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const fr_reset_request_sent = en_reset_request_sent;

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const de_reset_request_sent = en_reset_request_sent;

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const pt_reset_request_sent = en_reset_request_sent;

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const hi_reset_request_sent = en_reset_request_sent;

/** @type {(inputs: Reset_Request_SentInputs) => LocalizedString} */
const bn_reset_request_sent = en_reset_request_sent;

/**
* | output |
* | --- |
* | "If an account exists for that address, a reset link is on its way." |
*
* @param {Reset_Request_SentInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_request_sent = /** @type {((inputs?: Reset_Request_SentInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_SentInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_request_sent(inputs)
	if (locale === "he") return he_reset_request_sent(inputs)
	if (locale === "ur") return ur_reset_request_sent(inputs)
	if (locale === "es") return es_reset_request_sent(inputs)
	if (locale === "fr") return fr_reset_request_sent(inputs)
	if (locale === "de") return de_reset_request_sent(inputs)
	if (locale === "pt") return pt_reset_request_sent(inputs)
	if (locale === "hi") return hi_reset_request_sent(inputs)
	if (locale === "bn") return bn_reset_request_sent(inputs)
	return /** @type {LocalizedString} */ ("If an account exists for that address, a reset link is on its way.")
});